import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetSortedActiveProjects } from '../selectors/projects';
import { makeGetSortedActiveTaskGroups } from '../selectors/task-groups';

import { fetchTaskGroups } from '../actions/task-groups';

import { getTaskGroupsFetched, getTaskGroupsLoading } from '../services/store-service';

import Popout from './popout';
import Select from './select';

class TaskListSelector extends PureComponent {
    static deafaultProps = {
        title: 'SELECT TASK LIST',
        xAlign: 'left',
        defaultXPosition: 'right'
    };

    state = {
        selectedProject: this.props.projectId
    }

    handleProjectSelect = item => {
        this.setState({
            selectedProject: item.id
        });

        this.attemptFetchProjectTaskGroups(item.id);
    }

    handleCancelClick = () => {
        this.popoutCtrl.hide();
    }

    handleConfirmClick = () => {
        this.props.onSuccess && this.props.onSuccess(this.taskGroupSelectCtrl.getValue(), this.state.selectedProject);

        this.popoutCtrl.hide();
    }

    attemptFetchProjectTaskGroups(projectId) {
        if (projectId && !getTaskGroupsFetched(projectId) && !getTaskGroupsLoading(projectId)) {
            fetchTaskGroups(projectId);
        }
    }

    setPopoutCtrl = ctrl => this.popoutCtrl = ctrl;
    setProjectSelectCtrl = ctrl => this.projectSelectCtrl = ctrl;
    setTaskGroupSelectCtrl = ctrl => this.taskGroupSelectCtrl = ctrl;

    get selectedProjectTaskGroups() {
        if (!this.state.selectedProject) {
            return [];
        }

        return this.props.taskGroups.filter(taskGroup => taskGroup.project === this.state.selectedProject);
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            show: event => {
                return this.popoutCtrl.show(event);
            },
            hide: () => {
                return this.popoutCtrl.hide();
            }
        });

        this.attemptFetchProjectTaskGroups(this.props.projectId);
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }

    render() {
        return (
            <Popout
                provideController={this.setPopoutCtrl}
                className="dark-arrow xxsmall"
                xAlign={this.props.xAlign}
                defaultXPosition={this.props.defaultXPosition}
            >
                <div className="popout-head">
                    {this.props.title}
                </div>

                <div className="popout-main">
                    <div className="popout-body">
                        <Select
                            label="Task List"
                            provideController={this.setTaskGroupSelectCtrl}
                            options={this.selectedProjectTaskGroups.map(taskGroup => ({ id: taskGroup.id, text: taskGroup.name }))}
                        />

                        <Select
                            label="Project"
                            provideController={this.setProjectSelectCtrl}
                            onSelect={this.handleProjectSelect}
                            selected={this.props.projectId}
                            options={[
                                ...this.props.projects.map(project => ({
                                    id: project.id,
                                    text: project.name
                                }))
                            ]}
                        />
                    </div>
                </div>

                <div className="popout-foot">
                    <div className="btn-group">
                        <button className="btn btn-small btn-secondary" onClick={this.handleCancelClick}>Cancel</button>

                        <button className="btn btn-small btn-success" onClick={this.handleConfirmClick}>Move</button>
                    </div>
                </div>
            </Popout>
        )
    }
}

const makeMapStateToProps = () => {
    const getSortedActiveProjects = makeGetSortedActiveProjects();
    const getSortedActiveTaskGroups = makeGetSortedActiveTaskGroups();

    return ({ projects, taskGroups }, ownProps) => {
        return {
            projects: getSortedActiveProjects(projects.items, []),
            taskGroups: getSortedActiveTaskGroups(taskGroups.items)
        }
    }
};

export default connect(makeMapStateToProps)(TaskListSelector);
